import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { NgSelectScrollFixDirective } from './ng-select-scroll-fix.directive';
import { PrecisionFormatDirective } from './precision-format.directive';
import { RestrictDirective } from './restrict.directive';
import { TrimOnFocusoutDirective } from './trim-on-focusout.directive';


@NgModule({
  imports: [CommonModule],
  declarations: [
   RestrictDirective,
   PrecisionFormatDirective,
   TrimOnFocusoutDirective,
   InfiniteScrollDirective,
   NgSelectScrollFixDirective
  ],
  exports: [RestrictDirective,PrecisionFormatDirective,TrimOnFocusoutDirective,InfiniteScrollDirective,NgSelectScrollFixDirective]

})
export class DirectivesModule {
  static forRoot(): ModuleWithProviders<DirectivesModule> {
    return {
      ngModule: DirectivesModule
    };
  }
}
